module.exports = __webpack_public_path__ + "static/media/app-preview.8e5cfa2a.png";